import { render, staticRenderFns } from "./select_cbdw.vue?vue&type=template&id=4ba6d672&scoped=true&"
import script from "./select_cbdw.vue?vue&type=script&lang=js&"
export * from "./select_cbdw.vue?vue&type=script&lang=js&"
import style0 from "./select_cbdw.vue?vue&type=style&index=0&id=4ba6d672&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba6d672",
  null
  
)

export default component.exports